/**
 * 供货
 */
/**
 * table 时配置 config 的属性：
 * {
 *   align:'left || right || center',  // 对齐方式
 *   border: border: '1 || bottom || top || left || right ',  // 边线
 *   more: true || false,  // 是否显示查看更多
 *   fixed: true || false, // 是否将左侧第一行进行固定,并且滚动右侧
 *   code: 'String', // 查看更多时的接口code
 *   title: 'String', // 查看更多时的标题
 *   code: 'String', // 查看城市下面的项目的接口code
 *   title: 'String', // 查看城市下的项目标题
 *   highlight: false || true // 是否高亮(false 为高亮，true 不高亮)
 *   leftHighLight: false || true // 是否左侧高亮
 *   showExecTime: false || true // 是否显示更新时间(false 为高亮，true 不高亮)
 *   isClick: false || true // 是否可以点击，false 为可点击 ， true 为不可点击
 * }
 * */
const MB_GH_CONFIG = {
  // 供货概要
  'MB-GH-S-GHGY': [
    {
      chartType: 'customSupplySchema',
      interfaceCode: 'GH_GHGY_SYB_N',
      orgType: 'SYB',
      config: {
        align: 'left',
        border: '',
        highlight: false,
        more: false,
        fixed: true,
        showExecTime: true,
        twoPageConfig: { title: '供货概要' },
        returnGetData:true,
      }
    }
  ],
  'MB-GH-C-GHGY': [
    {
      chartType: 'customSupplySchema',
      interfaceCode: 'GH_GHGY_CS_T',
      orgType: 'CITY',
      config: {
        align: 'left',
        border: '',
        highlight: false,
        more: false,
        fixed: true,
        showExecTime: true,
        twoPageConfig: { title: '供货概要' },
        returnGetData:true,
      }
    }
  ],

  // 月度供货达成
  'MB-GH-S-YDGHDC': [
    {
      chartType: 'customSupplyMonth',
      interfaceCode: 'GH_YDGHDC_SYB_N',
      orgType: 'SYB',
      config: {
        align: 'left',
        border: '',
        highlight: true,
        more: true,
        fixed: true, // 是否固定左侧和滚动头部
        twoPageConfig: { title: '各项目月度供货情况' },
        customTitle:'本月各项目供货达成情况',
        returnGetData:true,
        seriesConfig: [
          {
            name: '计划供货金额(亿)',
            type: 'bar',
            barGap: 0,
            selected: true,
            color: '#C2E5D9'
          },
          {
            name: '实际供货金额(亿)',
            type: 'bar',
            barGap: '-100%',
            selected: true,
            color: '#0D9869'
          },
          {
            name: '供货达成率',
            type: 'line',
            selected: true,
            yAxisIndex: 1,
            barGap: 0,
            unit:'%',
            color: '#E8AF46'
          }
        ],
        yAxisConfig: [
          {
            name: '亿',
            show: true,
            position: 'left',
            nameAlign: 'right'
          },
          {
            name: '%',
            show: true,
            position: 'right',
            nameAlign: 'left'
          }
        ],
        showDataZoom:true
      }
    }
  ],
  'MB-GH-C-YDGHDC': [
    {
      chartType: 'customSupplyMonth',
      interfaceCode: 'GH_YDGHDC_CS_T',
      orgType: 'CITY',
      config: {
        align: 'left',
        border: '',
        highlight: true,
        more: true,
        fixed: true, // 是否固定左侧和滚动头部
        twoPageConfig: { title: '各项目月度供货情况' },
        returnGetData:true,
        customTitle:'本月各项目供货达成情况',
        seriesConfig: [
          {
            name: '计划供货金额(亿)',
            type: 'bar',
            barGap: 0,
            selected: true,
            color: '#C2E5D9'
          },
          {
            name: '实际供货金额(亿)',
            type: 'bar',
            barGap: '-100%',
            selected: true,
            color: '#0D9869'
          },
          {
            name: '供货达成率',
            type: 'line',
            selected: true,
            unit:'%',
            yAxisIndex: 1,
            barGap: 0,
            color: '#E8AF46'
          }
        ],
        yAxisConfig: [
          {
            name: "亿",
            show: true,
            position: 'left',
            nameAlign: 'right'
          },
          {
            name: '%',
            show: true,
            position: 'right',
            nameAlign: 'left'
          }
        ],
        showDataZoom:true
      }
    }
  ],

  // 年度供货达成
  'MB-GH-S-NDGHDC': [
    {
      chartType: 'customSupplyYear',
      interfaceCode: 'GH_NDGHDC_SYB_N',
      orgType: 'SYB',
      config: {
        align: 'left',
        border: '',
        highlight: true,
        more: true,
        fixed: true, // 是否固定左侧和滚动头部
        twoPageConfig: { title: '年度供货达成' },
        returnGetData:true,
        // 双y轴配置
        yAxisConfig: [
          {
            name: '亿',
            show: true,
            position: 'left',
            nameAlign: 'right'
          },
          {
            name: '%',
            show: true,
            position: 'right',
            nameAlign: 'left',
            max: 100
          }
        ],
        seriesConfig: [
          {
            name: '计划供货金额(亿)',
            type: 'bar',
            barGap: 0,
            selected: true,
            color: '#C2E5D9'
          },
          {
            name: '实际供货金额(亿)',
            type: 'bar',
            barGap: '-100%',
            selected: true,
            color: '#0D9869'
          },
          {
            name: '供货达成率',
            type: 'line',
            selected: true,
            yAxisIndex: 1,
            unit:'%',
            barGap: 0,
            color: '#E8AF46'
          }
        ],
        customTitle: '全国供货达成情况',
      }
    }
  ],
  'MB-GH-C-NDGHDC': [
    {
      chartType: 'customSupplyYear',
      interfaceCode: 'GH_NDGHDC_CS_T',
      orgType: 'CITY',
      config: {
        align: 'left',
        border: '',
        highlight: true,
        more: true,
        fixed: true, // 是否固定左侧和滚动头部
        twoPageConfig: { title: '年度供货达成' },
        returnGetData:true,
        yAxisConfig: [
          {
            name: '亿',
            show: true,
            position: 'left',
            nameAlign: 'right'
          },
          {
            name: '%',
            show: true,
            position: 'right',
            nameAlign: 'left'
          }
        ],
        seriesConfig: [
          {
            name: '计划供货金额(亿)',
            type: 'bar',
            barGap: 0,
            selected: true,
            color: '#C2E5D9'
          },
          {
            name: '实际供货金额(亿)',
            type: 'bar',
            barGap: '-100%',
            selected: true,
            color: '#0D9869'
          },
          {
            name: '供货达成率',
            type: 'line',
            selected: true,
            yAxisIndex: 1,
            barGap: 0,
            unit:'%',
            color: '#E8AF46'
          }
        ],
        customTitle: '全国供货达成情况',
      }
    }
  ],

  // 首开供货达成情况
  'MB-GH-S-SKGHDC': [
    {
      chartType: 'customSupplyFirst',
      interfaceCode: 'GH_SKGHDC_SYB_N',
      orgType: 'SYB',
      config: {
        align: 'left',
        border: '',
        highlight: true,
        more: true,
        // fixed: true, // 是否固定左侧和滚动头部
        twoPageConfig: { title: '首开项目供货情况' },
        returnGetData:true,
        customLegend: true,
        customTitle: '首开供货情况',
        seriesConfig: [
          {
            name: '计划供货金额(亿)',
            type: 'bar',
            barGap: 0,
            selected: true,
            color: '#C2E5D9',
            label:true
          },
          {
            name: '实际供货金额(亿)',
            type: 'bar',
            barGap: '-100%',
            selected: true,
            color: '#0D9869'
          },
          {
            name: '供货达成率',
            type: 'line',
            selected: true,
            yAxisIndex: 1,
            barGap: 0,
            unit:'%',
            color: '#E8AF46'
          }
        ],
        yAxisConfig: [
          {
            name: '亿',
            show: true,
            position: 'left',
            nameAlign: 'right'
          },
          {
            name: '%',
            show: true,
            position: 'right',
            nameAlign: 'left'
          }
        ],
        showDataZoom:true
      }
    }
  ],
  'MB-GH-C-SKGHDC': [
    {
      chartType: 'customSupplyFirst',
      interfaceCode: 'GH_SKGHDC_CS_T',
      orgType: 'CITY',
      config: {
        align: 'left',
        border: '',
        highlight: true,
        more: true,
        // fixed: true, // 是否固定左侧和滚动头部
        twoPageConfig: { title: '首开项目供货情况' },
        returnGetData:true,
        customLegend: true,
        customTitle: '首开供货情况',
        seriesConfig: [
          {
            name: '计划供货金额(亿)',
            type: 'bar',
            barGap: 0,
            selected: true,
            color: '#C2E5D9',
            label:true
          },
          {
            name: '实际供货金额(亿)',
            type: 'bar',
            barGap: '-100%',
            selected: true,
            color: '#0D9869'
          },
          {
            name: '供货达成率',
            type: 'line',
            selected: true,
            yAxisIndex: 1,
            barGap: 0,
            unit:'%',
            color: '#E8AF46'
          }
        ],
        yAxisConfig: [
          {
            name: '亿',
            show: true,
            position: 'left',
            nameAlign: 'right'
          },
          {
            name: '%',
            show: true,
            position: 'right',
            nameAlign: 'left'
          }
        ],
        showDataZoom:true
      }
    }
  ]
};

const upgradeConfig = {
  ...MB_GH_CONFIG
};

export default upgradeConfig;
